import Vue from 'vue';
import {
    getReservation, updateReservation
} from '../../../services/crmService/reservationService';

import {
    getReservationTypeList, getMemberEventReservationTimeList, storeEventReservation, getEventStoreDropdown
} from '../../../services/personnelService/reservationService';

import {
    getEventActivityReservationEditData, updateEventActivityReservation
} from '../../../services/personnelService/eventActivityReservationService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
    reservations: [],
    pagination: {
        current_page: 0,
        per_page: 5
    },
    reservationsTypeList: [],
    reservationTimeList: [],
    reservationAllTimeList: {},
    reservationStores: [],
    editData: {}
};

// getters
const getters = {};

// actions
const actions = {
    // 取得預約列表
    async getReservationHandler({ commit }, statusInfo) {
        const data = await getReservation(statusInfo);
        commit('setReservations', data);
    },
    // 取得預約種類
    async getReservationTypeListHandler({ commit }) {
        const data = await getReservationTypeList();
        commit('setReservationsTypeList', data.data);
    },
    // 拿取可預約時間列表
    async getReservationTimeListHandler({ commit }, updateInfo) {
        const query = Object.keys(updateInfo).map(key => `${key}=${updateInfo[key]}`).join('&');
        const data = await getMemberEventReservationTimeList(query);
        commit('setReservationTimeList', data.data);
        return data;
    },
    // 修改預約
    async updateReservationHandler({}, updateInfo) {
        await updateReservation(updateInfo);
    },
    // 送出預約
    async storeReservationHandler({}, updateInfo) {
        await storeEventReservation(updateInfo);
    },
    // 取得Event活動專賣店下拉
    async getEventStoreDropdownHandler({commit}, updateInfo) {
        const data = await getEventStoreDropdown(updateInfo);
        commit('setReservationStore', data.data);
    },
    // 取得編輯時資料
    async getEventActivityReservationEditDataHandler({commit}, updateInfo) {
        const data = await getEventActivityReservationEditData(updateInfo);
        commit('setEditData', data.data);
    },
    // 送出編輯
    async updateEventActivityReservationHandler({commit}, updateInfo) {
        const data = await updateEventActivityReservation(updateInfo);
        commit('setEditData', data.data);
    }
};

// mutations
const mutations = {
    setReservations(state, data) {
        Vue.set(state, 'reservations', state.reservations.concat(data.data.reservations));
        Vue.set(state, 'pagination', data.pagination);
    },
    setReservationsTypeList(state, data) {
        Vue.set(state, 'reservationsTypeList', data['reservation-list']);
    },
    // 重置所有資料
    resetHandler(state) {
        Vue.set(state, 'reservations', []);
        Vue.set(state, 'pagination', {
            current_page: 0,
            per_page: 5
        });
    },
    setReservationTimeList(state, data) {
        Vue.set(state, 'reservationAllTimeList', data);
    },
    setReservationStore(state, data) {
        Vue.set(state, 'reservationStores', data['activity-store']);
    },
    setEditData(state, data) {
        Vue.set(state, 'editData', data.activity_reservation);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
